import { UnitName, UnitPhoto } from '$shared/components';
import { CellButton } from '$uikit';
import { BottomSheet } from '$uikit/BottomSheet/BottomSheet';
import React, { ReactNode, useEffect, useState } from 'react';
import { FollowersBottomSheetProps } from './FollowersBottomSheet.interface';
import { useDispatch } from 'react-redux';
import { followersActions } from '$store/followers';
import { useCurrentUserInfo, useTranslator } from '$hooks';
import './FollowersBottomSheet.sass';
import { IcDelete28 } from '$assets';

export const FollowersBottomSheet = ({
  user,
  onClose,
  buttons,
}: FollowersBottomSheetProps) => {
  const [title, setTitle] = useState<ReactNode | string>('');
  const [content, setContent] = useState<ReactNode>(null);
  const dispatch = useDispatch();
  const currentUser = useCurrentUserInfo();
  const t = useTranslator();

  const renderDeleteContent = () => {
    const content = (
      <div className="FollowersBottomSheet__delete">
        <div className="FollowersBottomSheet__delete__head">
          <UnitPhoto
            unit={user}
            onlineIndicator={false}
            nftIndicator={false}
            size="big"
          />
          <div className="FollowersBottomSheet__delete__head_header">
            {t('followers_remove_header')}
          </div>
          <div className="FollowersBottomSheet__delete__head_description">
            <b>
              <UnitName unit={user} inclineCase="nominative" />
            </b>{' '}
            {t('followers_remove_description')}
          </div>
        </div>
        <div className="FollowersBottomSheet__delete__content">
          <CellButton
            onClick={() => {
              dispatch(
                followersActions.deleteFollower({
                  deletedUserId: user.id,
                  currentUserId: currentUser.id,
                }),
              );
              onClose();
            }}
            className="FollowersBottomSheet__redBtn"
          >
            {t('followers_remove_button')}{' '}
            <UnitName unit={user} inclineCase="accusative" namePart="firstName" />
          </CellButton>
          <CellButton onClick={onClose}>{t('followers_remove_cancel_button')}</CellButton>
        </div>
      </div>
    );

    setContent(content);
    setTitle('');
  };

  useEffect(() => {
    if (typeof buttons === 'string') {
      switch (buttons) {
        case 'delete':
          setContent(
            <CellButton onClick={renderDeleteContent} icon={<IcDelete28 />} size="small">
              {t('followers_remove_follower')}
            </CellButton>,
          );
          setTitle(<UnitName unit={user} />);
          break;
      }
    }
  }, []);

  return (
    <BottomSheet
      scroll={false}
      title={title}
      onClose={onClose}
      className="FollowersBottomSheet"
    >
      <div className="FollowersBottomSheet__content">{content}</div>
    </BottomSheet>
  );
};
